import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerFeedbackService } from '../../../../service/customer-feedback.service';
import {
  CustomerFeedbackResponse,
  CustomerFeedbackItem,
} from 'src/app/share/type/customer-ratings_type';

@Component({
  selector: 'app-customer-feedback',
  templateUrl: './customer-feedback.component.html',
  styleUrls: ['./customer-feedback.component.scss'],
})
export class CustomerFeedbackComponent implements OnInit, OnDestroy, OnChanges {
  @Input() productId!: string;

  // Component state
  public feedbackData: CustomerFeedbackResponse | null = null;
  public isLoading: boolean = false;
  public hasError: boolean = false;
  public selectedSorting: string = 'HIGHEST';

  // Sorting options
  public sortingOptions = [
    /* { value: 'RELEVANCE', label: 'Relevanz' }, */
    { value: 'NEWEST', label: 'Neueste' },
    { value: 'HIGHEST', label: 'Höchste' },
    { value: 'LOWEST', label: 'Niedrigste' },
  ];

  private subscription: Subscription;

  // Component properties for display
  get feedbackItems(): CustomerFeedbackItem[] {
    return this.feedbackData?.feedbackItems || [];
  }

  get hasNext(): boolean {
    return this.feedbackData?.hasNext || false;
  }

  get hasPrevious(): boolean {
    return this.feedbackData?.hasPrevious || false;
  }

  constructor(private customerFeedbackService: CustomerFeedbackService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    // Handle both initial load and subsequent changes
    if (changes['productId'] && changes['productId'].currentValue) {
      this.loadCustomerFeedback();
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private loadCustomerFeedback(
    cursor: string = '',
    sortingEnum: string = this.selectedSorting
  ): void {
    if (!this.productId) {
      this.hasError = true;
      return;
    }

    this.isLoading = true;
    this.hasError = false;

    this.subscription = this.customerFeedbackService
      .getCustomerFeedback(this.productId, 4, cursor, sortingEnum)
      .subscribe({
        next: (data: CustomerFeedbackResponse | null) => {
          if (data) {
            this.feedbackData = data;
          } else {
            this.hasError = true;
          }
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Failed to load customer feedback:', error);
          this.hasError = true;
          this.isLoading = false;
        },
      });
  }

  // Sorting method
  onSortingChange(): void {
    this.loadCustomerFeedback('', this.selectedSorting);
  }

  // Pagination methods - handle API calls directly with service caching
  nextPage(): void {
    if (this.hasNext && this.feedbackData?.nextCursor) {
      this.loadCustomerFeedback(
        this.feedbackData.nextCursor,
        this.selectedSorting
      );
    }
  }

  previousPage(): void {
    if (this.hasPrevious && this.feedbackData?.prevCursor) {
      this.loadCustomerFeedback(
        this.feedbackData.prevCursor,
        this.selectedSorting
      );
    }
  }

  trackBySortingOption(index: number, option: { value?: string }): string {
    return option?.value ?? `${index}`;
  }

  trackByFeedbackItem(index: number, feedback: CustomerFeedbackItem): string {
    return `${feedback.date}-${feedback.authorName}-${feedback.rating}-${feedback.comment ?? ''}`;
  }
}
